import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import './Katalog.css';
import {
    Switch,
    Route,
    useRouteMatch,
    useParams
} from "react-router-dom";
import MenuTop from '../../components/MenuTop/MenuTop.js';
import KatalogSklepy from './KatalogSklepy.js';
import KatalogStart from './KatalogStart';
import KatalogSzukaj from './KatalogSzukaj';
const DAO_SKLEP_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/sklepy';

export default function Katalog() {
    let { path } = useRouteMatch();
    return (
        <Container fluid className="p-0">
            <Row className="menu-top shadow-sm">
                <Col className="mt-2 mb-2">
                    <MenuTop />
                </Col>
            </Row>
            <Row className="katalog">
                <Col  >
                    <Switch>
                        <Route path={`${path}/szukaj/:str`}>
                            <KatalogSzukaj />
                        </Route>
                        <Route path={`${path}/sklepy/:str`}>
                            <KatalogSklepy />
                        </Route>
                        <Route path={`${path}/sklepy`}>
                            <KatalogSklepy />
                        </Route>
                        <Route path={`${path}/:str`}>
                            <KatalogStart />
                        </Route>
                        <Route  >
                            <KatalogStart />
                        </Route>
                    </Switch>
                </Col>
            </Row>
        </Container>
    );


}
